import * as Linking from "expo-linking";
import { Platform } from "react-native";
import { AddressType } from "src/common/types/response/user";
import { SelectedAddressType } from "../types/EditProfileScreen";

interface Location {
  latitude: string;
  longitude: string;
}

const openMap = (location: Location) => {
  let url;
  if (Platform.OS === "android") {
    url = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
  } else if (Platform.OS === "ios") {
    url = `http://maps.apple.com/?ll=${location.latitude},${location.longitude}`;
  }

  Linking.openURL(url);
};

const getAddress = (address: AddressType): SelectedAddressType => {
  const { line_1, line_2, city, location } = address || {};
  const description = `${line_1}, ${line_2}, ${city}`;
  return {
    name: address?.address_name,
    description,
    location,
  };
};

export { openMap, getAddress };
